import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$orgPid/analytics/')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$orgPid/analytics/occupancy',
      params,
      search,
    });
  },
});
